export default __webpack_public_path__ + "static/media/ga.4257c8ec.svg";